/* eslint-disable @typescript-eslint/no-explicit-any */
interface Window {
  ReactNativeWebView?: {
    postMessage: (message: string) => void;
  };
}
interface messageToAppProps{
  route?: string ;
  link?: string;
  json?: any;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
export const sendMessageToApp = ({ route, link, json }: messageToAppProps) => {
const win = window as Window

if (win.ReactNativeWebView) {
    console.log('Si hay un WebView')

    const message = {
        route: route ?? '',
        timestamp: new Date().toISOString(),
        data: json ?? undefined,
    }

    win.ReactNativeWebView.postMessage(JSON.stringify(message)) // Serializar a JSON
} else {
  console.log('Web no está dentro de WebView')

  if (!json && link)
    window.open(link, '_blank')
}

}
